import PropTypes from 'prop-types'
import React from 'react'
import config from 'Config'

const renderButtonContent = ({ loading, useLoader }) => {
  if (loading && useLoader) {
    return (
      <div className="spinner">
        <div className="bounce1"></div>
        <div className="bounce2"></div>
        <div className="bounce3"></div>
      </div>
    )
  }
  if (loading) {
    return (
      <span>{config.locale === 'de' ? 'Wird geladen...' : 'Loading...'}</span>
    )
  }
  return <span>{config.locale === 'de' ? 'Mehr laden' : 'Load more'}</span>
}

const LoadMoreButton = props => {
  const { className, onClick, isLoadingMore, useLoader } = props

  const loadMoreClass = isLoadingMore
    ? useLoader
      ? 'loading--use-loader'
      : 'loading'
    : ''

  return (
    <button
      onClick={onClick}
      className={`load-more-button ${className} ${loadMoreClass}`}
    >
      {renderButtonContent({
        loading: isLoadingMore,
        useLoader: useLoader
      })}
    </button>
  )
}

LoadMoreButton.propTypes = {
  className: PropTypes.any,
  isLoadingMore: PropTypes.any,
  onClick: PropTypes.any,
  useLoader: PropTypes.any
}

export default LoadMoreButton
